import { render, staticRenderFns } from "./OperaCommunityReviewWindow.vue?vue&type=template&id=354e6276"
import script from "./OperaCommunityReviewWindow.vue?vue&type=script&lang=js"
export * from "./OperaCommunityReviewWindow.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports